export function downloadBlob(url, filename) {
  const a = document.createElement("a");
  a.href = url; a.download = filename || "dosya";
  document.body.appendChild(a); a.click(); a.remove();
}

export function openInNewTab(url) {
  const a = document.createElement("a");
  a.href = url; a.target = "_blank"; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
}

// Prints via hidden iframe where the browser can render PDFs inline; otherwise opens a new tab.
export function printBlob(url, isPdf) {
  if (isPdf && navigator.pdfViewerEnabled === false) { openInNewTab(url); return; }
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  iframe.onload = () => {
    if (!isPdf) { setTimeout(() => iframe.remove(), 60000); return; }
    try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch { openInNewTab(url); }
    setTimeout(() => iframe.remove(), 60000);
  };
  if (isPdf) iframe.src = url;
  else iframe.srcdoc = `<html><body style="margin:0"><img src="${url}" style="max-width:100%" onload="window.print()"></body></html>`;
  document.body.appendChild(iframe);
}
